import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import a11ypanel from "../../../../assets/images/docs/a11ypanel.png";
import outline from "../../../../assets/images/docs/outline.png";
import syncedInteractions from "../../../../assets/images/docs/syncedinteractions.png";
import mediaEmulation from "../../../../assets/images/docs/media-emulation.png";
import screenshotoverview from "../../../../assets/images/docs/screenshot-overview.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  a11ypanel,
  outline,
  syncedInteractions,
  mediaEmulation,
  screenshotoverview,
  React
};